import util from 'util';
import { CONSTANT } from '@const';
import { WorkItemType } from '@types';

import { ApiParams, ApiService } from '../api/ApiService';

export class WorkService extends ApiService {
	static async getWorks(clientId: string): Promise<WorkItemType[]> {
		const params: ApiParams = {
			method: 'GET',
			url: util.format(`${CONSTANT.WORKS_API_URL}`, clientId),
		};
		return await this.executeApiRequest(params);
	}
}
